import { render, staticRenderFns } from "./Installers.vue?vue&type=template&id=48ac3c9a&scoped=true&"
import script from "./Installers.vue?vue&type=script&lang=js&"
export * from "./Installers.vue?vue&type=script&lang=js&"
import style0 from "./Installers.vue?vue&type=style&index=0&id=48ac3c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac3c9a",
  null
  
)

export default component.exports